<template>
  <EditingDialog
    :useDifferentShowDialogProp="true"
    :context="context + 'Conditions'"
    :showSnackbar="true"
    snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
  >
    <template v-slot:editForm>
      <v-container fluid>
        <v-row>
          <v-col cols="6">
            <BaseEditPageDropdown
              field="SourceId"
              :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SOURCE')"
              :items="mappingsSourceOptions"
              :context="context + 'Conditions'"
              :withMargin="false"
              :alvqa="alvqa + '-dropdown-source-id'"
              :resetValNull="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="6" class="text-right">
            <template>
              <BaseEditPageAutocomplete
                :context="context + 'Conditions'"
                field="RecipientId"
                :label="conditionRecipient"
                :withFreeText="false"
                :withMargin="false"
                :alvqa="
                  alvqa + '-erp-conditions-recipient-textfield-autocomplete'
                "
              >
                <template v-slot:selection="{ item }">
                  <div
                    class="ellipsis"
                    :alvqa="
                      alvqa + '-autocomplete-conditions-recipient-selection'
                    "
                  >
                    {{ $alvPlugin.showNameOfAzEntry(item) }}
                  </div>
                </template>
                <template v-slot:items="{ items }">
                  <v-list-item-content
                    :alvqa="
                      alvqa +
                      '-autocomplete-conditions-recipient-dropdown-' +
                      items.alvId
                    "
                  >
                    <v-list-item-title
                      :alvqa="
                        alvqa +
                        '-autocomplete-conditions-recipient-dropdown-' +
                        items.alvId +
                        '-title'
                      "
                    >
                      {{ $alvPlugin.showNameOfAzEntry(items) }}
                      <!--  
                                  typeOfAz:
                                      allowed values: P, D or G
                                      P => Person => P in circle
                                      D => Distributor => D in circle (in german V for 'Vertrieb')
                                      G => Group => G in circle                                                
                                  -->
                      <v-avatar color="grey" size="20" class="caption">{{
                        items.typeOfAz
                      }}</v-avatar>
                      <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                    </v-list-item-title>
                    <v-list-item-subtitle
                      :alvqa="
                        alvqa +
                        '-autocomplete-conditions-recipient-dropdown-' +
                        items.alvId +
                        '-subtitle'
                      "
                    >
                      {{ $t("lang_IPI") }}:
                      {{
                        items.ipi !== null &&
                        items.ipi !== "" &&
                        items.ipi !== undefined
                          ? items.ipi
                          : $t("lang_GENERIC_CAPTION_NOMEN_NOMINANDUM")
                      }}
                      | {{ items.alvId }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </BaseEditPageAutocomplete>
            </template>
          </v-col>
        </v-row>
        <!-- SVAV fields - only for AUV contract type -->
        <v-row v-if="isAuvContract">
          <v-col cols="6">
            <BaseEditPageTextField
              :context="context + 'Conditions'"
              field="SvavPublisherQuota"
              :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SVAV_PUBLISHER_QUOTA')"
              :withMargin="false"
              rules="percentDecimal"
              :alvqa="alvqa + '-textfield-svav-publisher-quota'"
              suffix="%"
              :additionalFunction="resetSvavShareType"
            />
          </v-col>
          <v-col cols="6">
            <BaseEditPageDropdown
              field="SvavShareType"
              :label="$t('lang_PUBLISHING_CAPTION_SHARE_TYPE')"
              :items="svavShareTypeItems"
              :context="context + 'Conditions'"
              :withMargin="false"
              :alvqa="alvqa + '-dropdown-svav-share-type'"
              :rules="getSvavPublisherQuota != null ? 'required' : ''"
              :disabled="getSvavPublisherQuota === null"
              :resetValNull="true"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EditingDialog>
</template>

<script>
import EditingDialog from "@/components/_dialogs/EditingDialog";
import BaseEditPageAutocomplete from "@/components/_editForm/BaseEditPageAutocomplete";
import BaseEditPageDropdown from "@/components/_editForm/BaseEditPageDropdown";
import BaseRegions from "@/components/_base/BaseRegions";
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField';
import {
  DropdownWeightingSource,
} from "@/assets/dropdowns/alvDropdowns.js";

export default {
  name: "PublishingContractsWorksEditPanelDialog",
  components: {
    BaseEditPageAutocomplete,
    BaseEditPageDropdown,
    BaseRegions,
    EditingDialog,
    BaseEditPageTextField,
  },
  data() {
    return {
      items: [],
      searchId: null,
      context: "PublishingContract",
      alvqa: "contracts-publishing-edit-form-add-conditions-dialog",
    };
  },
  computed: {
    conditionRecipient() {
      return this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_RECIPIENT");
    },
    mappingsSourceOptions() {
      let retList = this.$store.getters.getAzForMappingsImport.map((el) => {
        let elCopy = {...el}
        let displayText = elCopy.text
        if (this.$alvPlugin.isLangConst(elCopy.text)) {
          displayText = this.$t(elCopy.text)
          elCopy.text = displayText
        } else {
          elCopy.text = `${displayText} (${elCopy.value})`
        }
        return elCopy;
      });

      return retList;
    },
    getSelectedRecipient() {
      return this.$store.getters.getPublishingContractConditionsDetailsRecipientId;
    },
    isAuvContract() {
      return this.$store.getters.getPublishingContractsDetailsContractType === 'AUV';
    },
    getSvavPublisherQuota() {
      return this.$store.getters.getPublishingContractConditionsDetailsSvavPublisherQuota;
    },
    getSocieties() {
      let data = this.$store.getters.getAzSocietiesWhereDirectMember
      let retArr = []
      let homeSociety = JSON.parse(localStorage.getItem("userData"))['user']['homeSocietyCode']
      let homeSocietyName = this.$alvPlugin.getSocietyPanelHeadline(parseInt(homeSociety))

      retArr.push({
        value: homeSociety,
        text: homeSocietyName,
        alvqa: this.alvqa + `-svav-share-type-society-${homeSocietyName}`
      })
      
      // Prepare data for dropdown
      data.forEach((v) => {
          if (parseInt(v.societyCode) != parseInt(homeSociety) && v.societyCode !== null) {
            retArr.push({
                value: v.societyCode,
                text: this.$alvPlugin.getSocietyPanelHeadline(v.societyCode),
                alvqa: this.alvqa + `-svav-share-type-society-${v.societyAcronym}`
            })
          }
      })

      return retArr
    },
    svavShareTypeItems() {
      let shareTypes = DropdownWeightingSource;
      let societiesOfUser = this.getSocieties
      
      return shareTypes.concat(societiesOfUser);
    }
  },
  methods: {
    resetSvavShareType() {
      if (this.getSvavPublisherQuota == null || this.getSvavPublisherQuota == '') {
        this.$store.commit('setPublishingContractConditionsDetailsSvavShareType', null)
        this.$store.commit('setPublishingContractConditionsDetailsSvavPublisherQuota', null)
      }
    },
  },
  created() {
    this.$store.dispatch("fetchAzForMappings");
  },
};
</script>
